<template>
    <div class="viewJUSTF" v-if="dados">
        <div class="modal-conteudo m-2">
            <div id="divImprimir">
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h4 class="txt-p txt-w-7 txt-size-16 mb-0"> {{dados.dsTitulo}}</h4>
                        <h4 class="txt-p txt-w-4 txt-size-14"> {{dados.dsSubTitulo}}</h4>
                    </div>
                    <div class="col-md-12">
                        <h6 class="txtApp">Relator(a):</h6>
                        <span class="regular" v-html="dados.dsRelator"></span>
                    </div>
                    <div class="col-md-12" v-if="dados.dsRelatorDecisao">
                        <h6 class="txtApp">Relator(a) da Decisão:</h6>
                        <span class="regular" v-html="dados.dsRelatorDecisao"></span>
                    </div>
                    <div class="col-md-12">
                        <h6 class="txtApp">Julgamento:</h6>
                        <span class="regular" v-html="dados.dtJulgamento"></span>
                    </div>
                    <div class="col-md-12">
                        <h6 class="txtApp">Publicação:</h6>
                        <span class="regular" v-html="dados.dtPublicacao"></span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12" v-if="dados.dsPublicacao">
                        <h6 class="txtApp">Publicação:</h6>
                        <span class="regular" v-html="dados.dsPublicacao"></span>
                    </div>
                    <div class="col-md-12" v-if="dados.dsPartes">
                        <h6 class="txtApp">Partes:</h6>
                        <span class="regular" v-html="dados.dsPartes"></span>
                    </div>
                    <div class="col-md-12" v-if="dados.dsDecisao">
                        <h6 class="txtApp">Decisão:</h6>
                        <span class="regular" v-html="dados.dsDecisao"></span>
                    </div>
                    <div class="col-md-12" v-if="dados.dsLegislacao">
                        <h6 class="txtApp">Legislação:</h6>
                        <span class="regular" v-html="dados.dsLegislacao"></span>
                    </div>
                    <div class="col-md-12" v-if="dados.dsObservacao">
                        <h6 class="txtApp">Observação:</h6>
                        <span class="regular" v-html="dados.dsObservacao"></span>
                    </div>
                </div>                     
            </div>
        </div>
        

        <div class="modal-footer pb-0 mt-4 d-flex justify-content-end">
            <a :href="dados.urlLink" class="btn-default bg-solid-primary txt-size-14" target="_blank" v-if="dados.urlLink">
                <i class="fas fa-external-link-alt"></i> Acessar Jurisprudência
            </a>
            <a :href="dados.urlPdf" class="btn-default bg-solid-primary txt-size-14" target="_blank" v-if="dados.urlPdf">
                <i class="fas fa-file-pdf"></i> Inteiro teor
            </a>

            <button class="btn-default bg-solid-primary txt-size-14" @click="imprimir">
                <i class="fas fa-print"></i> Imprimir
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'viewJUSTF',
        components: { },
        data: function () {
            return {
                tpConteudo: 'Pesquisa',
                cdConteudo: 'JUSTF',
            }
        },
        props: {
            dados: Object,
        },
        methods: {
            
            imprimir() {
                var conteudo = document.getElementById('divImprimir').innerHTML,
                    tela_impressao = window.open('about:blank');

                tela_impressao.document.write(conteudo);
                tela_impressao.window.print();
                tela_impressao.window.close();
            },
        },
        mounted: function () {
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
   
</style>

